<!--
 * @Author: baiwei
 * @Date: 2020-04-02 16:35:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-27 16:51:23
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <div class="module">
        <helpInfo :helpData='helpData'>
            <div slot="slotR"
                 class="back-div"
                 @click="$router.go(-1)">
                <Icon type="ios-arrow-dropleft"
                      size="16" />
                <span>{{$t('返回')}}</span>
            </div>
        </helpInfo>
        <div class="module-container ugdetail-pack">
            <DetailInfo title="基本信息">
                <a v-if="!info.sysDefault && hasPermission('CH0202')"
                   slot="titleR"
                   class="icon-edit-o"
                   @click="editUserGroup"></a>
                <Item label="组名称"
                      :title="info.groupName"
                      :value="info.groupName" />
                <Item label="创建时间"
                      :value="info.createdDt" />
                <Item label="描述">
                    <Tooltip placement="bottom"
                             max-width="350"
                             theme="light">
                        <p style="width: 220px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{info.description}}</p>
                        <div slot="content"
                             style="white-space: normal;word-break: break-all;word-wrap: break-word;">{{info.description}}</div>
                    </Tooltip>
                </Item>
            </DetailInfo>
            <Tabs v-model="tabVal"
                  :animated="false"
                  class="tab-pack"
                  type="card">
                <TabPane :label="$t('用户')"
                         v-if="hasPermission('CH021001')"
                         name="user">
                    <User ref="user"
                          @refresh="init"></User>
                </TabPane>
                <TabPane :label="$t('权限')"
                         v-if="hasPermission('CH021002')"
                         name="polices">
                    <Polices ref="polices"
                             :disabled="info.sysDefault"
                             @refresh="init"></Polices>
                </TabPane>
            </Tabs>
        </div>
        <userGroupForm ref="userGroupForm"
                       @refresh="init"></userGroupForm>
    </div>
</template>
<script>
import helpInfo from '@c/basic/helpinfo'
import { DetailInfo, Item } from '@c/basic/rcdetailinfo'
import User from './components/user'
import Polices from './components/polices'
import userGroupForm from './components/usergroupform'
import API from '@/service/api.js'
export default {
    name: 'usergroupdetail',
    components: {
        helpInfo,
        DetailInfo,
        Item,
        User,
        Polices,
        userGroupForm
    },
    data () {
        return {
            helpData: {
                modelName: this.$t('用户组详情')
            },
            id: this.$route.params.id,
            info: {},
            tabVal: 'user'
        }
    },
    created () {
        this.init()
    },
    methods: {
        init () {
            if (!this.id) return
            this.axios.get(this.urlFormat(API.ACCESS_USERGROUP, false, [this.id])).then(res => {
                this.helpData.modelName = this.$t('用户组详情') + '-' + res.groupName
                this.info = res
                this.$refs.user.initData(res.subusers, res.groupSid)
                this.$refs.polices.initData(res.policies, res.groupSid)
            })
        },
        editUserGroup () {
            if (this.info.groupSid) {
                this.$refs.userGroupForm.open(this.info)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.ugdetail-pack {
}
</style>
